import { data } from "./data";

const IsoCertificationPage = () => (
  <div className="iso-certification-page">
    <h2>ISO Certification</h2>
    {data &&
      data.map((certificate, index) => (
        <div key={index} className="certificates">
          <a target="_blank" href={certificate.link} rel="noopener noreferrer">
            <h3>{certificate.title}</h3>{" "}
          </a>
        </div>
      ))}
  </div>
);

export default IsoCertificationPage;
